var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ConnectionInfoEntry_1;
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
const ConnectionInfoEntrySchema = {
    $id: 'urn:wisepipe-common-connection:ConnectionInfoEntry',
    type: 'object',
    properties: {
        clientID: { type: 'string', minLength: 1 }
    },
    required: ['clientID']
};
let ConnectionInfoEntry = ConnectionInfoEntry_1 = class ConnectionInfoEntry {
    constructor(clientID) {
        this.clientID = clientID;
        JSON.validate(this, ConnectionInfoEntry_1);
    }
};
ConnectionInfoEntry = ConnectionInfoEntry_1 = __decorate([
    JsonSchema(ConnectionInfoEntrySchema)
], ConnectionInfoEntry);
export { ConnectionInfoEntry };
//# sourceMappingURL=connectionInfoEntry.js.map